var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1045_1355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 8.55003V7.00004C16.0035 5.95268 15.7696 4.91812 15.3158 3.97416C14.862 3.03021 14.2002 2.20141 13.38 1.55003C12.5504 0.879634 11.5785 0.407706 10.5386 0.170268C9.49876 -0.0671697 8.41839 -0.0638313 7.38 0.180034C5.81641 0.558786 4.42812 1.45808 3.44318 2.73014C2.45823 4.00221 1.93522 5.57141 1.96002 7.18003V8.55003H-0.039978V22.55H17.96V8.55003H16ZM4 7.15C3.9708 6.19466 4.21605 5.25097 4.70667 4.43071C5.19728 3.61044 5.91268 2.94801 6.76819 2.52183C7.6237 2.09565 8.58347 1.92363 9.53375 2.0261C10.484 2.12858 11.385 2.50125 12.13 3.10002C12.7138 3.56863 13.1849 4.16238 13.5085 4.83738C13.8322 5.51239 14.0001 6.25145 14 7.00004V8.55003H4V7.15ZM16 20.55H2V10.55H16V20.55Z",
    fill: "#ABB0BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13.55H8V16.55H10V13.55Z",
    fill: "#ABB0BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1045_1355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 22.55,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a7b3426d20a683ec000edc01b5769e0a.svg";
export { ForwardRef as ReactComponent };